import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';

@Component({
  standalone: false,
  selector: 'nimbus-section-wrapper',
  templateUrl: './section-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionWrapperComponent implements OnInit, OnChanges {
  @HostBinding('class')
  public class: string = 'nimbus-section-wrapper';

  @Input()
  public sectionLabel: string;

  public Icons = ICONS;
  public TranslationKeys = TranslationKeys;

  public hasTopSpace: boolean = false;

  public ngOnInit(): void {
    this.initialize();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.sectionLabel) {
      this.initialize();
    }
  }

  private initialize(): void {
    this.hasTopSpace = !!this.sectionLabel;
  }
}
